/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFlowContainer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M3 7h2v2H3zm0 4h2v2H3zm0-8h2v2H3zm4 16h2v2H7zm-4-4h2v2H3zm8-12h2v2h-2zM3 19h2v2H3zM7 3h2v2H7zm5 11.4 3.7-3.7-1.4-1.4-1.3 1.3V7h-2v3.6L9.7 9.3l-1.4 1.4zM19 7h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm0-12h2v2h-2zm-4 16h2v2h-2zm-4 0h2v2h-2zm4-16h2v2h-2zm4 16h2v2h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgFlowContainer as FlowContainer };
